import { IAPIAction, ITemplateEditorAction } from "interfaces";
import { TemplateEditor } from "constants/Actions";

const {
  SELECT_TEMPLATE_SECTION,
  REFORM_SECTION_RULES,
  UPDATE_SECTION_RULE,
  DELETE_SECTION_RULE,

  UPDATE_SECTION,
  UPDATE_SECTION_SUCCESS,
  UPDATE_SECTION_FAIL,

  GET_PARAMETERS,
  GET_PARAMETERS_SUCCESS,
  GET_PARAMETERS_FAIL,
  RESET_PARAMETERS_SUCCESS,

  GET_SECTIONS,
  GET_SECTIONS_SUCCESS,
  GET_SECTIONS_FAIL,
  SAVE_SECTIONS,

  RESET_PREVIEW_DATA,

  SAVE_TEMPLATE_RULE,
  SAVE_TEMPLATE_RULE_SUCCESS,
  SAVE_TEMPLATE_RULE_FAIL,

  GET_TEMPLATE_RULES,
  GET_TEMPLATE_RULES_SUCCESS,
  GET_TEMPLATE_RULES_FAIL,
  RESET_TEMPLATE_RULES,
  MANAGE_EDITOR_DRAWER,

  GET_PREVIEW_DATA,
  GET_PREVIEW_DATA_SUCCESS,
  GET_PREVIEW_DATA_FAIL,

  GET_REPEATING_ADAPTERS,
  GET_REPEATING_ADAPTERS_SUCCESS,
  GET_REPEATING_ADAPTERS_FAIL,

  GET_REPEATING_ADAPTER_TOKENS,
  GET_REPEATING_ADAPTER_TOKENS_SUCCESS,
  GET_REPEATING_ADAPTER_TOKENS_FAIL,

  SET_EDITOR_SETTINGS,
  SET_EDITOR_SETTINGS_SUCCESS,
  SET_EDITOR_SETTINGS_FAIL,

  GET_TEMPLATE_PREVIEW,
  GET_TEMPLATE_PREVIEW_SUCCESS,
  GET_TEMPLATE_PREVIEW_FAIL,
  RESET_TEMPLATE_PREVIEW,
} = TemplateEditor;

export const templateEditor: Readonly<IAPIAction & ITemplateEditorAction> = {
  section: {
    selectSection: (data) => ({
      type: SELECT_TEMPLATE_SECTION,
      payload: {
        data,
        isLoading: true,
      },
    }),
    reformRules: (data) => ({
      type: REFORM_SECTION_RULES,
      payload: {
        data,
        isLoading: true,
      },
    }),
    updateRule: (data) => ({
      type: UPDATE_SECTION_RULE,
      payload: {
        data,
        isLoading: true,
      },
    }),
    deleteRule: (data) => ({
      type: DELETE_SECTION_RULE,
      payload: {
        data,
        isLoading: true,
      },
    }),
    update: (data) => ({
      type: UPDATE_SECTION,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: UPDATE_SECTION_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: UPDATE_SECTION_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  parameters: {
    get: (data) => ({
      type: GET_PARAMETERS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_PARAMETERS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_PARAMETERS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    reset: (data) => ({
      type: RESET_PARAMETERS_SUCCESS,
      payload: {
        data,
        isLoading: true,
      },
    }),
  },
  sections: {
    get: (data) => ({
      type: GET_SECTIONS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    save: (data) => ({
      type: SAVE_SECTIONS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_SECTIONS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_SECTIONS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  templateRules: {
    get: (data) => ({
      type: GET_TEMPLATE_RULES,
      payload: {
        data,
        isLoading: true,
      },
    }),
    manageDrawer: (data) => ({
      type: MANAGE_EDITOR_DRAWER,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_TEMPLATE_RULES_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_TEMPLATE_RULES_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    reset: (data) => ({
      type: RESET_TEMPLATE_RULES,
      payload: {
        data,
        isLoading: true,
      },
    }),
  },
  templateRule: {
    save: (data) => ({
      type: SAVE_TEMPLATE_RULE,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SAVE_TEMPLATE_RULE_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SAVE_TEMPLATE_RULE_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  previewData: {
    get: (data) => ({
      type: GET_PREVIEW_DATA,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_PREVIEW_DATA_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_PREVIEW_DATA_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    reset: (data) => ({
      type: RESET_PREVIEW_DATA,
      payload: {
        data,
        isLoading: true,
      },
    }),
  },
  repeatingAdapters: {
    get: (data) => ({
      type: GET_REPEATING_ADAPTERS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_REPEATING_ADAPTERS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_REPEATING_ADAPTERS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  repeatingAdapterTokens: {
    get: (data) => ({
      type: GET_REPEATING_ADAPTER_TOKENS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_REPEATING_ADAPTER_TOKENS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_REPEATING_ADAPTER_TOKENS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  editorSettings: {
    set: (data) => ({
      type: SET_EDITOR_SETTINGS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SET_EDITOR_SETTINGS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SET_EDITOR_SETTINGS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  templatePreview: {
    get: (data) => ({
      type: GET_TEMPLATE_PREVIEW,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_TEMPLATE_PREVIEW_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_TEMPLATE_PREVIEW_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    reset: (data) => ({
      type: RESET_TEMPLATE_PREVIEW,
      payload: {
        data,
        isLoading: true,
      },
    }),
  },
};
